import { createFileRoute } from "@tanstack/react-router";
import TMSConsultation from "@/pages/TMSConsultation";
export const Route = createFileRoute("/tms-consultation")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS Consultation | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Schedule a free TMS consultation at Neuro Wellness in Coral Springs, FL. Learn if SAINT® TMS or standard TMS is right for your treatment-resistant depression.",
        },
        {
          property: "og:title",
          content: "TMS Consultation | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Schedule a free TMS consultation at Neuro Wellness in Coral Springs, FL. Learn if SAINT® TMS or standard TMS is right for your treatment-resistant depression.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/tms-consultation",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/tms-consultation",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TMSConsultation />;
}
